// Portable container for one encrypted attachment — PWVA v1.
//
// Layout:
//   magic     4   "PWVA"
//   version   1   uint8
//   nonce    12   bytes
//   ct      var   ciphertext (AES-GCM, includes the 16-byte tag)
//
// No salt/iterations: an attachment is encrypted under the same vault key as
// the vault blob (whose salt/iters live in vault.enc). If the layout changes,
// bump the version and add a new branch — never reinterpret an old file.

import { NONCE_BYTES } from '../crypto/vault-crypto.js';

const MAGIC = new Uint8Array([0x50, 0x57, 0x56, 0x41]); // "PWVA"
const VERSION = 1;
const HEADER_BYTES = 4 /*magic*/ + 1 /*version*/ + NONCE_BYTES;

export function encodeAttachmentBlob({ nonce, ciphertext }) {
  if (!(nonce instanceof Uint8Array) || nonce.byteLength !== NONCE_BYTES) {
    throw new Error('encodeAttachmentBlob: nonce missing or wrong length');
  }
  if (!(ciphertext instanceof Uint8Array)) {
    throw new Error('encodeAttachmentBlob: ciphertext missing');
  }
  const out = new Uint8Array(HEADER_BYTES + ciphertext.byteLength);
  let o = 0;
  out.set(MAGIC, o); o += 4;
  out[o++] = VERSION;
  out.set(nonce, o); o += NONCE_BYTES;
  out.set(ciphertext, o);
  return out;
}

export function decodeAttachmentBlob(bytes) {
  if (!(bytes instanceof Uint8Array) || bytes.byteLength < HEADER_BYTES) {
    throw new Error('decodeAttachmentBlob: input too short / truncated');
  }
  for (let i = 0; i < MAGIC.length; i++) {
    if (bytes[i] !== MAGIC[i]) throw new Error('decodeAttachmentBlob: bad magic');
  }
  const version = bytes[4];
  if (version !== VERSION) throw new Error(`decodeAttachmentBlob: unsupported version ${version}`);
  const nonce = bytes.slice(5, 5 + NONCE_BYTES);
  const ciphertext = bytes.slice(5 + NONCE_BYTES);
  return { version, nonce, ciphertext };
}
